/**
 * @generated SignedSource<<b622a6900029430625d3470f35c9bcfc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedFAQ_itemSearch$data = {
  readonly meta: {
    readonly header: string | null;
  } | null;
  readonly questionsAnswers: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SharedFAQQuestion_question">;
  } | null> | null;
  readonly " $fragmentType": "SharedFAQ_itemSearch";
};
export type SharedFAQ_itemSearch$key = {
  readonly " $data"?: SharedFAQ_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedFAQ_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedFAQ_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuestionType",
      "kind": "LinkedField",
      "name": "questionsAnswers",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedFAQQuestion_question"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "eb9a246c93c9d81eacc5ca431cecb225";

export default node;
